export default function NuestraMisiNInspiradora() {
  return <section data-section-id="223297" id="nuestra-misión-inspiradora" className="dark bg-background text-foreground py-24 md:py-32 lg:py-48 flex items-center justify-center min-h-screen selection:bg-primary/30 selection:text-primary-foreground">
      <div className="w-full px-6 md:w-3/5 mx-auto flex flex-col items-center text-center space-y-12 md:space-y-16">
        {}
        <span className="text-8xl md:text-9xl text-primary leading-none font-default block -mb-12 md:-mb-16 select-none opacity-80" aria-hidden="true">
          &ldquo;
        </span>

        {}
        <p className="text-2xl md:text-3xl lg:text-4xl font-default leading-relaxed md:leading-loose text-foreground/90 tracking-wide">
          La música tiene el poder de inspirar y transformar vidas. En Rolver Music Productions, creamos canciones y producciones musicales con propósito, diseñadas para transmitir fe, esperanza e inspiración. Cada proyecto es una oportunidad para glorificar a Dios y conectar corazones a través de la música.
        </p>

        {}
        <div className="pt-8 md:pt-12 flex flex-col items-center gap-4">
          <span className="text-4xl md:text-5xl font-default italic text-secondary block tracking-wider">Rolver Music Productions</span>
          <div className="h-px w-12 bg-primary/30 rounded-md" />
          <span className="text-xs md:text-sm text-muted-foreground uppercase tracking-[0.2em] font-default">
            Producciones con Propósito
          </span>
        </div>
      </div>
    </section>;
}